import { registerBrick, EnumValue } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';
import {Box, MenuItem, FormControl,Select,Chip} from '@mui/material'
import { red, blue, green, grey } from '@mui/material/colors';
import { styled, ThemeProvider, createTheme } from '@mui/material/styles';

export default class SelectWithChip extends ReactBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @return {Element}
     */
    static getReactComponent($) {
        return () => {
            const ITEM_HEIGHT = 98;
            const ITEM_PADDING_TOP = 8;
            const MenuProps = {
                PaperProps: {
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                        width: 150,
                    },
                },
            };

            // Set Chip color based on progress state
            const chipTheme = createTheme({
                palette: {
                    'multiSelect': {
                        main: grey[400],
                        contrastText: grey[400]
                    },

                    'Completed': {
                        main: green[800],
                        contrastText: green[800]
                    },
                    'Not started': {
                        main: red[900],
                        contrastText: red[900]
                    },
                    'Default': {
                        main: blue[500],
                        contrastText: blue[500]
                    }

                }
            });

            const STATUS_COLOR = {
                'Completed': green[800],
                'Not started': red[900],
                'Default': blue[500]
            };

            const [progressState, setProgressState] = React.useState([]);
            const [labels, setLabel] = React.useState('');
            const isMultiSelect = useProperty($, 'Multi Select');
            const enumData = $.get('enum');    
            let menuData =   [];
            // check Enum input Provided or not
            if(enumData){
                const en = enumData.getValues().toArray();
                // EnumValue to get value in enum input data
                menuData = en.map(x=>(x.get(EnumValue.nameProp)));
            }          
            const handleChange = (event) => {
                // This component support Multi-select and single select
                // Add a selected value in placeholder base on 'Multi select' property
                if (isMultiSelect) {
                    const {
                        target: { value },
                    } = event;
                    setLabel('multiSelect');
                    // On autofill, we get a stringified value.
                    const selectedValue = (typeof value === 'string' ? value.split(',') : value);
                    // update selected Value props for output
                    $.set('selected Value', selectedValue);
                    setProgressState(selectedValue);
                   
                }
                else {
                    const selectedValue = event.target.value.at(-1);
                    //update chip component color based on Selected progress state
                    const label = Object.keys(STATUS_COLOR).includes(selectedValue) ? selectedValue : 'Default';
                    selectedValue ? setLabel(label) : null;
                    // update selected Value props for output
                    selectedValue ? $.set('selected Value',[selectedValue]) : null;                    
                    selectedValue ? setProgressState([selectedValue]) : null;
                }

            };

            const StyledSelect = styled(Select)(() => ({
                '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.23)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline ': {
                    borderBottom: '1px solid #F19100'
                }
            }));

            return (
                <div>
                    <FormControl sx={{ m: 1, width: 200 }}>

                        <StyledSelect
                            labelId="demo-multiple-chip-label"
                            id="demo-multiple-chip"
                            multiple
                            value={progressState}
                            onChange={handleChange}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <ThemeProvider theme={chipTheme} key={value}>
                                            <Chip key={value} label={value} variant="outlined" color={labels} sx={{ border: '2px solid', fontWeight: 'bold' }} />
                                        </ThemeProvider>
                                    ))}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                        >
                            {menuData ? menuData.map((name) => (
                                <MenuItem key={name} value={name} >
                                    {name}
                                </MenuItem>
                            )) : null}
                        </StyledSelect>
                    </FormControl>
                </div>
            );
        };
    }
}

registerBrick('018cd38e7c96dbe964f3', SelectWithChip);
